"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeafKeyCoder = void 0;
const helpers_1 = require("../utils/helpers");
class LeafKeyCoder {
    static decode(key) {
        return (typeof key === 'string' ? Buffer.from(helpers_1.evenHex(helpers_1.remove0x(key)), 'hex') : key).toString('utf-8');
    }
}
exports.LeafKeyCoder = LeafKeyCoder;
LeafKeyCoder.encode = (key) => {
    const bytes = 32;
    const buff32 = Buffer.alloc(bytes).fill(0);
    const value = Buffer.from(key);
    if (value.length > 32) {
        throw Error(`key overflow: got ${value.length} bytes`);
    }
    value.copy(buff32, bytes - value.length);
    return buff32;
};
//# sourceMappingURL=LeafKeyCoder.js.map